import React, { useState } from 'react';
import './HandDrawnButton.css';

interface HandDrawnButtonProps {
  text: string;
  onClick?: () => void;
  variant?: 'brand' | 'atacama' | 'iguazu' | 'mendoza' | 'patagonia' | 'santa-catarina';
  color?: 'awasi' | 'off-white' | 'white';
  animation?: 'stroke-to-fill' | 'fill-to-stroke' | 'stroke-to-stroke';
  size?: 'normal' | 'wide';
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const HandDrawnButton: React.FC<HandDrawnButtonProps> = ({
  text,
  onClick,
  variant = 'brand',
  color = 'awasi',
  animation = 'stroke-to-fill',
  size = 'normal',
  className = '',
  ariaLabel,
  disabled = false,
  type = 'button',
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Map variant names for Santa Catarina (file has space in name)
  const fileVariant = variant === 'santa-catarina' ? 'santa catarina' : variant;

  // Construct the SVG file paths for regular buttons
  let defaultImagePath: string;
  let hoverImagePath: string;

  if (size === 'wide') {
    // Wide buttons
    defaultImagePath = `/Buttons/Wide/state=Default, color=${color}, level=${fileVariant}.png`;
    hoverImagePath = `/Buttons/Wide/state=hover, color=${color}, level=${fileVariant}.png`;
  } else {
    // Normal buttons with SVG
    defaultImagePath = `/Buttons/Normal/state=Default, color=${color}, animation=${animation.replace(/-/g, ' ')}, level=${fileVariant}.svg`;
    hoverImagePath = `/Buttons/Normal/state=hover, color=${color}, animation=${animation.replace(/-/g, ' ')}, level=${fileVariant}.svg`;
  }

  // Regular button with SVG background
  return (
    <button
      className={`hand-drawn-button hand-drawn-button--${variant} hand-drawn-button--${color} hand-drawn-button--${animation} hand-drawn-button--${size} ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={ariaLabel || text}
      disabled={disabled}
      type={type}
    >
      <svg
        className="hand-drawn-button__svg"
        preserveAspectRatio="none"
        viewBox="0 0 97 41"
      >
        <image
          href={isHovered ? hoverImagePath : defaultImagePath}
          x="0"
          y="0"
          width="97"
          height="41"
          preserveAspectRatio="none"
        />
      </svg>
      <span className="hand-drawn-button__text">{text}</span>
    </button>
  );
};